export const guidelineText = 'Number of outgoing requests depends on number of Asset Owners';
